import { Box, Typography } from '@mui/material';
import { getCurrentOrgId } from 'client/modules/Auth/AuthReducer';
import ApiKeysList from 'client/modules/Settings/pages/ApiKeysPage/ApiKeysList';
import McpAccessLogList from 'client/modules/Settings/pages/ApiKeysPage/McpAccessLogList';
import McpConnectionsList from 'client/modules/Settings/pages/ApiKeysPage/McpConnectionsList';
import useOpenClose from 'client/util/useOpenClose';
import React from 'react';

import { useReadApiKeysQuery } from 'client/modules/Surveys/apiKeysSlice';
import Helmet from 'react-helmet';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

const messages = defineMessages({
  title: {
    id: 'ApiKeysSettings.Title',
    defaultMessage: 'Developer settings',
  },
  reset: {
    id: 'ApiKeysSettings.Reset',
    defaultMessage: 'Reset',
  },
  areYouSure: {
    id: 'ApiKeysSettings.AreYouSure',
    defaultMessage: 'Are you sure you want to reset your API key?',
  },
  yes: {
    id: 'ApiKeysSettings.Yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'ApiKeysSettings.No',
    defaultMessage: 'No',
  },
});

function ApiKeysPage() {
  const orgId = useSelector(getCurrentOrgId);
  const { data: apiKeys } = useReadApiKeysQuery(orgId);
  const [_open, _handleOpen, handleClose] = useOpenClose();
  const { formatMessage } = useIntl();
  const _handleReset = () => {
    handleClose();
  };
  return (
    <Box>
      <Helmet title={formatMessage(messages.title)} />
      <Typography variant="h6" component="h2" sx={{ mb: 1 }}>
        {formatMessage(messages.title)}
      </Typography>
      <ApiKeysList apiKeys={apiKeys} />
      <McpConnectionsList />
      <McpAccessLogList />
      {apiKeys?.length > 0 && (
        <Box sx={{ mt: 3 }}>
          <FormattedMessage
            id="ApiKeysSettings.BeSure"
            defaultMessage={
              'Be sure to keep your API key private. ' +
              'All API requests must be made over HTTPS and are authenticated via HTTP Bearer Authentication. See our {link} for more information.'
            }
            values={{
              link: (
                <a href="/apidocs">
                  <FormattedMessage
                    id="ApiKeysSettings.Documentation"
                    defaultMessage="REST API documentation"
                  />
                </a>
              ),
            }}
          />
        </Box>
      )}
    </Box>
  );
}
export default ApiKeysPage;
